document.addEventListener('DOMContentLoaded', () => {
	const preNavBanner = document.getElementById('pre-nav-banner');
	if(preNavBanner) {
		const removeBannerButton = document.getElementById('hide-banner');

		if(!sessionStorage.getItem('hideModal')) {
			preNavBanner.classList.remove('d-none');
		}

		removeBannerButton.addEventListener('click', function() {
			preNavBanner.classList.add('d-none');
			sessionStorage.setItem('hideModal', true);
		});
	}
});